import React, { useState } from "react";
import PropTypes from "prop-types";
import { useModel, useCart } from "../../../../hooks";
import Button from "wonderbly-components/lib/Button";
import { shouldRedirectToOptions } from "../../../CanvasDrawers/helpers";
import buildProductUrl from "../../../../utils/buildProductUrl";

const ProductHeroIIButtonAddToCart = (props) => {
  const { countryModel, eagleProduct, eagleModel, prismicProduct } = useModel();
  const { addItemToCart } = useCart();
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleCtaClick(e) {
    e.preventDefault();
    setIsSubmitting(true);

    const productData = {
      productId: props.productId,
      country: countryModel,
    };
    const productUrlData = {
      model: { eagleProduct, eagleModel, countryModel, prismicProduct },
      queryParams: {},
    };

    const shouldRedirect = await shouldRedirectToOptions(productData);

    // Link to formats page if product has product options
    if (
      shouldRedirect &&
      productUrlData.model.prismicProduct.formats?.enabled
    ) {
      window.location = buildProductUrl(productUrlData, { type: "formats" });
      // otherwise link to the options page
    } else if (shouldRedirect) {
      window.location = buildProductUrl(productUrlData, {
        type: "options",
        query: { addonPage: 1 },
      });
      // otherwise link directly to cart
    } else {
      addItemToCart({
        productId: props.productId,
      });
    }
  }

  return (
    <div className="ProductHeroII__button-wrap">
      <Button
        className="ProductHeroII__button"
        type="submit"
        onClick={handleCtaClick}
        isSubmitting={isSubmitting}
        disabled={isSubmitting}
      >
        {props.productCtaButtonText}
      </Button>
    </div>
  );
};

ProductHeroIIButtonAddToCart.propTypes = {
  productCtaButtonText: PropTypes.string,
  productId: PropTypes.string,
};

export default ProductHeroIIButtonAddToCart;
